import { useState, useEffect } from 'react'

const useDebounce = (value: any, delay = 1000): any => {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    return () => {
      clearTimeout(handler)
    }
    // eslint-disable-next-line
    }, [value])

  return debouncedValue
}

export default useDebounce
